import { Injectable } from "@angular/core";
import { ZpDataService } from "./zp-data.service";
import { IUser } from "../models/user.model";

@Injectable({
  providedIn: "root",
})
export class ProfessionalFeaturesService {
  private user: IUser;
  private refCode: string;
  private logoUrl: string;
  private statusAttachments: string;
  company: string;
  companyDetails: {
    userType?: string;
    professionalLicense?: string;
    funded?: boolean;
    hideSponsor?: boolean;
    directInvoice?: boolean;
    email?: string;
    company?: string;
    logo?: string;
    firstName?: string;
    lastName?: string;
  };
  mySharedPlans: any;

  constructor(private zpDataService: ZpDataService) {}

  async checkProfessionalCompanyDetails(user?) {
    try {
      let refCode;

      // Get user information
      if (!user) {
        this.user = await this.zpDataService.getUser();
        if (this.user && this.user.license) {
          refCode = this.user.license.refCode;
          console.log('userData - ', this.user);
        } else {
          refCode = this.user.refCode;
          console.log('userData - ', this.user);
        }
      } else if (user) {
        this.user = user;
        if (user.delegate) {
          refCode = user.delegate.clientRefCode; // assuming delegate also has refCode
          console.log('delegate refCode - ', refCode);
        }
        if (user.refCode && !user.delegate) {
          refCode = user.refCode;
          console.log('refCode - ', refCode);
        }
      }

      // Get company and sponsor information
      await this.zpDataService.setRefCode(refCode);
      this.companyDetails = await this.zpDataService.getRefCodeInfo();
      console.log('companyDetails - ', this.companyDetails);
      return this.companyDetails;

    } catch (error) {
      console.error('Error fetching user or company details:', error);
    }
  }
}
